// src/pages/public/_authShared.jsx
// Helpers visuales compartidos por las pantallas auth (mockup v4).
import EELogo from '../../components/EELogo';

export const AuthBack = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      width: 36,
      height: 36,
      borderRadius: 10,
      background: 'var(--bg-elev)',
      border: '1px solid var(--line)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 18,
      cursor: 'pointer',
    }}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
      <path d="M15 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </button>
);

export const AuthLogo = () => (
  <div style={{ marginBottom: 28, display: 'inline-flex' }}>
    <EELogo size={22} />
  </div>
);

export const Field = ({
  label,
  type = 'text',
  placeholder,
  hint,
  value,
  onChange,
  error,
  right,
  autoComplete,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 500 }}>{label}</label>
    <div style={{ position: 'relative' }}>
      <input
        type={type}
        placeholder={placeholder}
        value={value || ''}
        autoComplete={autoComplete}
        onChange={(e) => onChange && onChange(e.target.value)}
        style={{
          width: '100%',
          padding: '14px 16px',
          paddingRight: right ? 44 : 16,
          background: 'var(--bg-elev)',
          border: `1px solid ${error ? '#DC2626' : 'var(--line-strong)'}`,
          borderRadius: 12,
          fontSize: 15,
          color: 'var(--ink)',
          fontFamily: 'inherit',
          outline: 'none',
          boxSizing: 'border-box',
        }}
      />
      {right && (
        <div style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}>{right}</div>
      )}
    </div>
    {(hint || error) && (
      <div style={{ fontSize: 11, color: error ? '#DC2626' : 'var(--muted)' }}>{error || hint}</div>
    )}
  </div>
);

export const GoogleBtn = ({ onClick, disabled, children }) => (
  <button
    className="btn-secondary"
    onClick={onClick}
    disabled={disabled}
    style={{ cursor: disabled ? 'wait' : 'pointer', opacity: disabled ? 0.6 : 1 }}
  >
    <svg width="18" height="18" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.5 12.3c0-.8-.1-1.5-.2-2.3H12v4.4h5.9c-.3 1.4-1 2.6-2.2 3.3v2.7h3.5c2.1-1.9 3.3-4.7 3.3-8.1z" />
      <path fill="#34A853" d="M12 23c3 0 5.5-1 7.3-2.6l-3.5-2.7c-1 .7-2.2 1.1-3.8 1.1-2.9 0-5.3-2-6.2-4.6H2.2v2.9C4 20.6 7.7 23 12 23z" />
      <path fill="#FBBC05" d="M5.8 14.2c-.2-.7-.4-1.4-.4-2.2s.1-1.5.4-2.2V6.9H2.2C1.4 8.4 1 10.1 1 12s.4 3.6 1.2 5.1l3.6-2.9z" />
      <path fill="#EA4335" d="M12 5.4c1.6 0 3.1.6 4.2 1.6l3.1-3.1C17.5 2.1 15 1 12 1 7.7 1 4 3.4 2.2 6.9l3.6 2.9C6.7 7.4 9.1 5.4 12 5.4z" />
    </svg>
    {children}
  </button>
);

export const Divider = ({ text }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '20px 0' }}>
    <div style={{ flex: 1, height: 1, background: 'var(--line)' }} />
    <span style={{ fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.1em' }}>
      {text}
    </span>
    <div style={{ flex: 1, height: 1, background: 'var(--line)' }} />
  </div>
);

export const Stepper = ({ step }) => (
  <div style={{ display: 'flex', gap: 6, marginBottom: 24 }}>
    {[1, 2, 3].map((n) => (
      <div
        key={n}
        style={{
          flex: 1,
          height: 4,
          borderRadius: 999,
          background: n <= step ? 'var(--ink)' : 'var(--line)',
        }}
      />
    ))}
  </div>
);

export const ErrorBanner = ({ msg }) =>
  msg ? (
    <div
      style={{
        background: 'rgba(220,38,38,0.08)',
        border: '1px solid rgba(220,38,38,0.3)',
        color: '#DC2626',
        padding: '10px 12px',
        borderRadius: 10,
        fontSize: 13,
        marginBottom: 14,
      }}
    >
      {msg}
    </div>
  ) : null;
